import { useEffect, useState } from "react";
import { AppShell } from "../components/layout/AppShell";
import { StatCard, Skeleton } from "../components/ui/Primitives";
import { apiRequest, ApiError } from "../api/client";

interface RawStats {
  totalUsers: number;
  liveRooms: number;
  pendingReports: number;
  totalPosts: number;
  pendingWithdrawals: number;
}

export function DashboardPage() {
  const [stats, setStats] = useState<RawStats | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiRequest<RawStats>("/admin/dashboard/stats")
      .then(setStats)
      .catch((err) => setError(err instanceof ApiError ? err.message : "could not load stats"));
  }, []);

  const cards = [
    { label: "Total Users", key: "totalUsers" as const, tone: "gold" as const },
    { label: "Live Rooms", key: "liveRooms" as const, tone: "success" as const },
    { label: "Total Posts", key: "totalPosts" as const, tone: "neutral" as const },
    { label: "Pending Reports", key: "pendingReports" as const, tone: "danger" as const },
    { label: "Pending Withdrawals", key: "pendingWithdrawals" as const, tone: "warn" as const },
  ];

  return (
    <AppShell title="Dashboard">
      {error && <p className="mb-4 rounded-lg bg-danger-bg px-4 py-3 text-sm text-danger">{error}</p>}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((card) =>
          stats ? (
            <StatCard key={card.key} label={card.label} value={stats[card.key]} tone={card.tone} />
          ) : (
            <div key={card.key} className="rounded-xl border border-surface-border bg-surface-card p-5">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="mt-3 h-7 w-16" />
            </div>
          )
        )}
      </div>

      <p className="mt-8 text-sm text-ink-faint">
        Welcome to the 4Fun control center. Use the sidebar to manage every part of the platform — every action you
        take here that changes real data is recorded in the Audit Log.
      </p>
    </AppShell>
  );
}
